
import {defineComponent} from 'vue'
import { ReportFilter, ReportFilterType } from '@/model/models'
import Multiselect from "@vueform/multiselect"

export default defineComponent( {
  name: 'ReportSelectFilter',
  components: {
    Multiselect
  },
  props: {
    filter: ReportFilter,
    preselect: null
  },
  created() {
    this.selected = this.preselect ? this.preselect.split(',') : null
  },
  data() {
    return {
      selected: null
    }
  },
  emits: [
    'filter-changed'
  ],
  methods: {
    onSelect() {
      if (this.selected) {
        if (typeof this.selected === 'number') {
          this.$emit('filter-changed', { name:  this.filter?.name, value: String(this.selected) })
          return
        } else if (typeof this.selected === 'string') {
          this.$emit('filter-changed', { name:  this.filter?.name, value: this.selected })
          return
        } else if (typeof this.selected === 'object') {
          const values = Object.values(this.selected!)
          this.$emit('filter-changed', { name:  this.filter?.name, value: values.join(',') })
          return
        }
      }

      this.$emit('filter-changed', { name:  this.filter?.name, value: null })
    }
  },
  computed: {
    filterValues() {
      const values = this.filter!.values.map(v => {
        return v.length > 1 ? { value: v[0], label: v[v.length-1] } : v[0]
        })

      return values
    },
    isSingleSelect() {
      return this.filter?.type === ReportFilterType.SingleSelect
    },
    isMultiSelect() {
      return this.filter?.type === ReportFilterType.MultiSelect
    },
    isAutoComplete() {
      return this.filter?.type === ReportFilterType.AutoComplete
    }
  }
})
